import React from 'react';
import css from './PaymentTable.module.css';

export default function PaymentTable2(props) {
  const { style } = props;

  return (
    <div>
      <table style={style} className={css.table}>
        <tr>
          <th>ENTERPRISE</th>
          <th className={css.planCol}>NETWORK</th>
          <th className={css.planCol}>VERIFIED</th>
        </tr>
        <tr>
          <td>Enterprise Coaching Engagements Delivered Through Viveka</td>
          <td></td>
          <td>x</td>
        </tr>
        <tr>
          <td>Opportunity To Pitch Organizations For Exclusive Coaching Programs</td>
          <td></td>
          <td>x</td>
        </tr>
      </table>
      <table style={style} className={css.table}>
        <tr>
          <th>VERIFICATION REQUIREMENTS</th>
          <th className={css.planCol}></th>
          <th className={css.planCol}>VERIFIED</th>
        </tr>
        <tr>
          <td>Minimum 500 Hours of Documented Coaching Experience</td>
          <td></td>
          <td>Required</td>
        </tr>
        <tr>
          <td>At Least 2 Client Testimonials or References</td>
          <td></td>
          <td>Required</td>
        </tr>
        <tr>
          <td>ICF Credential (ACC, PCC, MCC) or 20+ Years Professional Experience</td>
          <td></td>
          <td>Required</td>
        </tr>
        <tr>
          <td>Completion of a Viveka Verification Call</td>
          <td></td>
          <td>Required</td>
        </tr>
      </table>
    </div>
  );
}
